<template>
  <div v-if="isLoading" class="bg-gray-100 p-2 rounded-md text-center my-2">Please wait</div>
  <div class="flex flex-col gap-5 p-4" :class="userlocs.length === 0 ? 'pb-48' : ''">
    <div class="flex flex-col gap-1">
      <p class="text-gray-700">Please provide your location to receive relevant information and ensure a seamless ordering experience.</p>
    </div>
    <V3GeolocationComponent @success="navigate" />
    <UDivider label="OR" />
    <div>
      <p class="text-gray-700">Search your location</p>
    </div>
    <V3LocationFinderComponent @success="navigate" />
    <div class="flex flex-col gap-2 my-2" v-if="userlocs.length > 0">
      <p class="text-gray-500">Recent Locations</p>
      <div class="rounded-md p-2 cursor-pointer" v-for="loc in userlocs" :key="loc.id" @click="setLocation(loc)">
        <div class="inline-flex items-start gap-2">
          <UIcon name="i-heroicons-map-pin" class="h-5 w-5 mt-1 flex shrink-0" />
          <p class="text-gray-700 text-sm">{{ formatLocation(loc) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
const emit = defineEmits(["success", "close"]);

const isLoading = ref(false);
const location = useLocation();
const userlocs = ref([]);

const navigate = async () => {
  isLoading.value = true;
  // Ensure location is updated before hiding the loading
  setTimeout(() => {
    if (location.isGPSEnabled && location.city.code) {
      isLoading.value = false;
      emit("success");
     // emit("close");
    }
  }, 1000);
};

// Watch for location updates
watch(
  () => location.city.code,
  (newVal) => {
    if (newVal) {
      isLoading.value = false; // Hide loading indicator
      emit("success");
    }
  }
);

onMounted(() => {
  const userlocsRaw = localStorage.getItem("userlocs");
  userlocs.value = userlocsRaw ? JSON.parse(userlocsRaw) : [];
});

const formatLocation = (loc) => {
  if (isValidAddress(loc)) {
    return updateFormattedAddress(loc); // Pass `loc`, not `location`
  } else {
    return [
      loc.address_line1,
      loc.address_line2,
      loc.address_line3,
      loc.city?.name,
      loc.state?.name,
      loc.area_code &&
      !`${loc.address_line1} ${loc.address_line2} ${loc.address_line3} ${loc.city?.name} ${loc.state?.name}`.includes(loc.area_code)
        ? loc.area_code
        : null,
    ]
      .filter(Boolean) // Remove empty values
      .join(" ");
  }
};

const updateFormattedAddress = (loc) => {
  if (!loc?.formatted_address || !loc?.area_code) return loc?.formatted_address || "";

  const areaCodePattern = /\b\d{6}\b/;
  if (areaCodePattern.test(loc.formatted_address)) {
    return loc.formatted_address.replace(areaCodePattern, loc.area_code);
  }

  return `${loc.formatted_address} ${loc.area_code}`.trim();
};

const isValidAddress = (address) => {
  if (!address?.formatted_address?.trim()) return false;

  const addressPattern = /[a-zA-Z0-9\s.,#-]+/;
  return addressPattern.test(address.formatted_address) && (!address.address_line1 || address.address_line1.trim() === "");
};


const setLocation = async (loc) => {
  await location.setSavedAddress(loc);
  navigate();
};
</script>
